import { Button, ModalBody, ModalFooter, ModalHeader, useModal, useSnackbar } from "@homebound/beam";
import { useNavigate } from "react-router-dom";
import { createChangeEventsUrl } from "src/RouteUrls";
import { useDeleteChangeEventMutation } from "../../ChangeEventPage.generated";

type DeleteOrExitConfirmationModalProps = { changeEventId: string; projectId: string };

export function DeleteOrExitConfirmationModal(props: DeleteOrExitConfirmationModalProps) {
  const { changeEventId, projectId } = props;
  const { closeModal } = useModal();
  const { triggerNotice } = useSnackbar();
  const navigate = useNavigate();
  const [deleteChangeEventMutation] = useDeleteChangeEventMutation();

  function exit() {
    navigate(createChangeEventsUrl(projectId));
    closeModal();
  }

  return (
    <>
      <ModalHeader>Exit Without Saving?</ModalHeader>
      <ModalBody>
        You’re about to exit this workflow. Would you like to save a draft or delete this change event?
      </ModalBody>
      <ModalFooter>
        <Button label="Cancel" variant="quaternary" onClick={closeModal} />
        <Button
          label="Delete Draft"
          variant="secondary"
          onClick={async () => {
            await deleteChangeEventMutation({ variables: { input: { id: changeEventId } } });
            triggerNotice({ message: "Change event deleted" });
            exit();
          }}
        />
        <Button label="Save Draft" onClick={exit} />
      </ModalFooter>
    </>
  );
}
